// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
}

.bold-label {
  font-weight: bold !important;
  margin-bottom: 24px !important;
  display: block;
}

.epr-resources {
  /* Card header layout */
}
.epr-resources .resources-card__header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 1rem;
}
.epr-resources .section-card__title {
  margin-bottom: 0.25rem;
}
.epr-resources .resources-card__subtitle {
  margin: 0;
  font-size: 0.875rem;
  color: #444343;
}
.epr-resources .resources-card__actions {
  display: flex;
  gap: 0.5rem;
  margin-right: -0.625rem;
  flex-wrap: wrap;
  justify-content: flex-end;
}
.epr-resources {
  /* Add panel */
}
.epr-resources .resources-add-panel {
  margin-top: 1rem;
  padding: 1rem;
  border-radius: 10px;
  background-color: #EDEDED;
}
.epr-resources .resources-add-panel__heading {
  font-size: 0.9rem;
  margin-bottom: 0.85rem;
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 0.25rem;
}
.epr-resources .resources-add-panel__title {
  font-size: 1rem;
  font-weight: 600;
}
.epr-resources .resources-add-panel__subtitle {
  color: #444343;
  font-size: 1rem;
}
.epr-resources .input-container {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  align-items: flex-end;
}
.epr-resources .resources-field {
  display: flex;
  flex-direction: column;
  flex: 1 1 220px;
  font-size: 0.875rem;
}
.epr-resources .resources-field__label-text {
  margin-bottom: 0.25rem;
  font-weight: 500;
}
.epr-resources .browse-container {
  width: 100%;
}
.epr-resources .resources-input {
  background-color: white;
  border: 1px solid #A7A9AC;
  border-radius: 10px;
  font-size: 0.875rem;
  line-height: 1.5;
  padding: 0.375rem 0.75rem;
  width: 100%;
}
.epr-resources .alias-input,
.epr-resources .uri-description {
  border: 1px solid #A7A9AC;
  border-radius: 10px;
  font-size: 1rem;
  line-height: 1.5;
  padding: 0.375rem 0.75rem;
  width: 100%;
}
.epr-resources .resources-add-panel__hint {
  margin-top: 0.5rem;
  font-size: 0.9rem;
  color: #444343;
}
.epr-resources .resources-add-panel__footer {
  margin-top: 0.75rem;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
}
.epr-resources .upload-info__text {
  font-size: 0.85rem;
  color: #444343;
}
.epr-resources .resources-add-panel__actions {
  margin-top: 0.75rem;
  text-align: right;
}
.epr-resources .uri-container,
.epr-resources .uri-description-container {
  flex: 1 1 auto;
}
.epr-resources {
  /* Resources list */
}
.epr-resources .resources-list {
  margin-top: 1rem;
}
.epr-resources .resources-list__header {
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.5rem;
}
.epr-resources .resources-list__title {
  margin: 0;
  font-size: 0.95rem;
  font-weight: 600;
}
.epr-resources .resources-list__count {
  font-size: 0.95rem;
  color: #444343;
}
.epr-resources .resources-list__items {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}
.epr-resources .resource-line-item-container {
  padding: 0.75rem 0;
  border-top: 1px solid #444343;
}
.epr-resources .resource-resource {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 1rem;
}
.epr-resources .alias-container {
  flex: 1 1 auto;
}
.epr-resources .resource-main {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.epr-resources .resource-link {
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  margin-right: 0.5rem;
}
.epr-resources .resource-download-icon {
  cursor: pointer;
  font-size: 0.9rem;
}
.epr-resources .resource-type-label {
  margin-top: 0.25rem;
  font-size: 0.85rem;
  color: #444343;
}
.epr-resources .created-by {
  margin-top: 0.25rem;
  font-size: 0.85rem;
  color: #444343;
}
.epr-resources .resources-list__empty {
  padding: 0.85rem 0;
}
.epr-resources .resources-list__empty-text {
  font-size: 0.875rem;
  color: #6c757d;
}
.epr-resources {
  /* Responsive tweaks similar to Bootstrap's sm breakpoint */
}
@media (max-width: 768px) {
  .epr-resources .resources-card__header {
    flex-direction: column;
    align-items: flex-start;
  }
  .epr-resources .resources-card__actions {
    align-self: stretch;
    justify-content: flex-start;
  }
  .epr-resources .resource-resource {
    flex-direction: column;
    align-items: flex-start;
  }
  .epr-resources .resources-add-panel__footer {
    flex-direction: column;
    align-items: flex-start;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/global/Colors.scss","webpack://./src/styles/Resources.scss"],"names":[],"mappings":"AAAA;;;EAGI,sBAAA;ACCJ;;AAFA;EACI,4BAAA;EACA,8BAAA;EACA,cAAA;AAKJ;;AAFA;EAEI,uBAAA;AAIJ;AAHI;EACI,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,SAAA;AAKR;AAFI;EACI,sBAAA;AAIR;AADI;EACI,SAAA;EACA,mBAAA;EACA,cDOC;ACJT;AAAI;EACI,aAAA;EACA,WAAA;EACA,uBAAA;EACA,eAAA;EACA,yBAAA;AAER;AA3BA;EA4BI,cAAA;AAEJ;AADI;EACI,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,yBDzBA;AC4BR;AAAI;EACI,iBAAA;EACA,sBAAA;EACA,aAAA;EACA,eAAA;EACA,qBAAA;EACA,YAAA;AAER;AACI;EACI,eAAA;EACA,gBAAA;AACR;AAEI;EACI,cD3BC;EC4BD,eAAA;AAAR;AAGI;EACI,aAAA;EACA,eAAA;EACA,SAAA;EACA,qBAAA;AADR;AAII;EACI,aAAA;EACA,sBAAA;EACA,eAAA;EACA,mBAAA;AAFR;AAKI;EACI,sBAAA;EACA,gBAAA;AAHR;AAMI;EACI,WAAA;AAJR;AAOI;EACI,uBAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,WAAA;AALR;AAQI;;EAEI,yBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,WAAA;AANR;AASI;EACI,kBAAA;EACA,iBAAA;EACA,cD7EC;ACsET;AAUI;EACI,mBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,YAAA;AARR;AAWI;EACI,kBAAA;EACA,cD3FC;ACkFT;AAYI;EACI,mBAAA;EACA,iBAAA;AAVR;AAaI;;EAEI,cAAA;AAXR;AAlHA;EAgII,mBAAA;AAXJ;AAYI;EACI,gBAAA;AAVR;AAaI;EACI,mBAAA;EACA,aAAA;EACA,8BAAA;EACA,qBAAA;AAXR;AAcI;EACI,SAAA;EACA,kBAAA;EACA,gBAAA;AAZR;AAeI;EACI,kBAAA;EACA,cD5HC;AC+GT;AAgBI;EACI,aAAA;EACA,sBAAA;EACA,YAAA;AAdR;AAiBI;EACI,kBAAA;EACA,6BAAA;AAfR;AAkBI;EACI,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,SAAA;AAhBR;AAmBI;EACI,cAAA;AAjBR;AAoBI;EACI,aAAA;EACA,mBAAA;EACA,WAAA;AAlBR;AAqBI;EACI,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,oBAAA;AAnBR;AAsBI;EACI,eAAA;EACA,iBAAA;AApBR;AAuBI;EACI,mBAAA;EACA,kBAAA;EACA,cD3KC;ACsJT;AAwBI;EACI,mBAAA;EACA,kBAAA;EACA,cDjLC;AC2JT;AAyBI;EACI,kBAAA;AAvBR;AA0BI;EACI,mBAAA;EACA,cAAA;AAxBR;AA1LA;EAqNI,2DAAA;AAxBJ;AAyBI;EACI;IACI,sBAAA;IACA,uBAAA;EAvBV;EA0BM;IACI,mBAAA;IACA,2BAAA;EAxBV;EA2BM;IACI,sBAAA;IACA,uBAAA;EAzBV;EA4BM;IACI,sBAAA;IACA,uBAAA;EA1BV;AACF","sourcesContent":["*,\n*::before,\n*::after {\n    box-sizing: border-box;\n}\n// EPR colors\n// $dashboard-blue: #007bff; this color does not pass Accessibility. Updated version below.\n$dashboard-blue: #0d6efd;\n$dk-blue-toolbar: #19608f;\n$dk-blue: #0A4064;\n$lt-blue: #7DB7CC;\n$pale-blue: #c0def0;\n$information: #00AEEF;\n$information-hover: #02BFFF;\n$DCSD-logo-green: #84ae30;\n$text: #414042;\n$white: #EDEDED;\n$shadow: #525151;\n$red: #CB321A;\n$red-hover: #E2381D;\n$green: #C7CC68;\n\n$highlight: #FDF9D0;\n$important: #FEBF31;\n$lt-important: #FED883;\n$lt-highlight: #FAFAD2;\n$grey0: #EDF0F1;\n$grey1: #D1D3D4;\n$grey2: #A7A9AC;\n$grey3: #808080;\n$grey3a: #707070;\n$grey4: #636161;\n$grey4a: #444343;\n$pearl-blue: #0669B3;\n$pearl-blue-hover: #1786DB;\n$lt-pearl-blue: #63AEDE;\n$lt-pearl-blue-hover: #4589B3;\n\n$timeline-arrow-1: #718355;\n$timeline-arrow-2: #87986a;\n$timeline-arrow-3: #97a97c;\n$timeline-arrow-4: #b5c99a;\n$timeline-arrow-5: #cfe1b9;\n\n$permission-blue: #ADD8E6;\n$permission-green:#90EE90;\n$permission-orange: #FFA07A;\n","@import \"../styles/global/Colors\";\n\n.bold-label {\n    font-weight: bold !important;\n    margin-bottom: 24px !important;\n    display: block;\n}\n\n.epr-resources {\n\n    /* Card header layout */\n    .resources-card__header {\n        display: flex;\n        justify-content: space-between;\n        align-items: flex-start;\n        gap: 1rem;\n    }\n\n    .section-card__title {\n        margin-bottom: 0.25rem; // replaces mb-1\n    }\n\n    .resources-card__subtitle {\n        margin: 0;\n        font-size: 0.875rem;\n        color: $grey4a;\n    }\n\n    .resources-card__actions {\n        display: flex;\n        gap: 0.5rem;\n        margin-right: -0.625rem;\n        flex-wrap: wrap;\n        justify-content: flex-end;\n    }\n\n    /* Add panel */\n    .resources-add-panel {\n        margin-top: 1rem;\n        padding: 1rem;\n        border-radius: 10px;\n        background-color: $white;\n    }\n\n    .resources-add-panel__heading {\n        font-size: 0.9rem;\n        margin-bottom: 0.85rem;\n        display: flex;\n        flex-wrap: wrap;\n        align-items: baseline;\n        gap: 0.25rem;\n    }\n\n    .resources-add-panel__title {\n        font-size: 1rem;\n        font-weight: 600;\n    }\n\n    .resources-add-panel__subtitle {\n        color: $grey4a;\n        font-size: 1rem;\n    }\n\n    .input-container {\n        display: flex;\n        flex-wrap: wrap;\n        gap: 1rem;\n        align-items: flex-end;\n    }\n\n    .resources-field {\n        display: flex;\n        flex-direction: column;\n        flex: 1 1 220px;\n        font-size: 0.875rem;\n    }\n\n    .resources-field__label-text {\n        margin-bottom: 0.25rem;\n        font-weight: 500;\n    }\n\n    .browse-container {\n        width: 100%;\n    }\n\n    .resources-input {\n        background-color: white;\n        border: 1px solid $grey2;\n        border-radius: 10px;\n        font-size: 0.875rem;\n        line-height: 1.5;\n        padding: 0.375rem 0.75rem;\n        width: 100%;\n    }\n\n    .alias-input,\n    .uri-description {\n        border: 1px solid $grey2;\n        border-radius: 10px;\n        font-size: 1rem;\n        line-height: 1.5;\n        padding: 0.375rem 0.75rem;\n        width: 100%;\n    }\n\n    .resources-add-panel__hint {\n        margin-top: 0.5rem;\n        font-size: 0.90rem;\n        color: $grey4a;\n    }\n\n    .resources-add-panel__footer {\n        margin-top: 0.75rem;\n        display: flex;\n        flex-wrap: wrap;\n        align-items: center;\n        justify-content: space-between;\n        gap: 0.75rem;\n    }\n\n    .upload-info__text {\n        font-size: 0.85rem;\n        color: $grey4a;\n    }\n\n    .resources-add-panel__actions {\n        margin-top: 0.75rem;\n        text-align: right;\n    }\n\n    .uri-container,\n    .uri-description-container {\n        flex: 1 1 auto;\n    }\n\n    /* Resources list */\n    .resources-list {\n        margin-top: 1rem;\n    }\n\n    .resources-list__header {\n        align-items: center;\n        display: flex;\n        justify-content: space-between;\n        margin-bottom: 0.5rem;\n    }\n\n    .resources-list__title {\n        margin: 0;\n        font-size: 0.95rem;\n        font-weight: 600;\n    }\n\n    .resources-list__count {\n        font-size: 0.95rem;\n        color: $grey4a;\n    }\n\n    .resources-list__items {\n        display: flex;\n        flex-direction: column;\n        gap: 0.75rem;\n    }\n\n    .resource-line-item-container {\n        padding: 0.75rem 0;\n        border-top: 1px solid $grey4a;\n    }\n\n    .resource-resource {\n        display: flex;\n        justify-content: space-between;\n        align-items: flex-start;\n        gap: 1rem;\n    }\n\n    .alias-container {\n        flex: 1 1 auto;\n    }\n\n    .resource-main {\n        display: flex;\n        align-items: center;\n        gap: 0.5rem;\n    }\n\n    .resource-link {\n        cursor: pointer;\n        display: inline-flex;\n        align-items: center;\n        gap: 0.35rem;\n        margin-right: 0.5rem;\n    }\n\n    .resource-download-icon {\n        cursor: pointer;\n        font-size: 0.9rem;\n    }\n\n    .resource-type-label {\n        margin-top: 0.25rem;\n        font-size: 0.85rem;\n        color: $grey4a;\n    }\n\n    .created-by {\n        margin-top: 0.25rem;\n        font-size: 0.85rem;\n        color: $grey4a;\n    }\n\n    .resources-list__empty {\n        padding: 0.85rem 0;\n    }\n\n    .resources-list__empty-text {\n        font-size: 0.875rem;\n        color: #6c757d;\n    }\n\n    /* Responsive tweaks similar to Bootstrap's sm breakpoint */\n    @media (max-width: 768px) {\n        .resources-card__header {\n            flex-direction: column;\n            align-items: flex-start;\n        }\n\n        .resources-card__actions {\n            align-self: stretch;\n            justify-content: flex-start;\n        }\n\n        .resource-resource {\n            flex-direction: column;\n            align-items: flex-start;\n        }\n\n        .resources-add-panel__footer {\n            flex-direction: column;\n            align-items: flex-start;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
